import { gql } from '@apollo/client'
import { userErrorFragment } from '~/graphql/fragments/userError'

export const REMOVE_TWITTER_ACCOUNT = gql`
  mutation removeTwitterAccount($input: RemoveTwitterAccountInput!) {
    removeTwitterAccount(input: $input) {
      user {
        id
        twitterAccount {
          id
        }
      }
      errors {
        ...userError
      }
    }
  }
  ${userErrorFragment}
`
